module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0046.jpg?v=e7d2e278";